import styled from 'styled-components/macro';
import ArrowSliderLeftSVG from 'media/icons/arrow-slider-left.svg';
import Breakpoints from 'themes/constants/breakpoints';
import BasicJournalsCard from 'components/Jouranls/card/JournalsCard';

export const JournalsSliderMainWrap = styled.div<{ isDark?: boolean }>`
    & .swiper-container {
        width: 100%;
        padding-bottom: 22px;
        overflow: visible;
    }
    & .swiper-scrollbar {
        width: auto;
        height: 2px;
        left: 0;
        right: 0;
        bottom: 0;
        background: ${({ theme }) => theme.background.swiper.scrollbar.scrollbar.primary};
    }
    & .swiper-slide {
        display: flex;
        justify-content: center;
        align-items: stretch;
    }
    & .swiper-scrollbar-drag {
        background: ${({ theme }) => theme.background.swiper.scrollbar.drag.primary};
    }
    & .swiper-button-prev,
    & .swiper-button-next {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 58px;
        height: 58px;
        z-index: 10000;
        border-radius: 24px;
        background: ${({ theme }) => theme.background.button.slider};
        color: ${({ theme }) => theme.color.button.slider};
        box-shadow: ${({ theme }) => theme.boxShadow.card.journal};
        cursor: pointer;
        &:after {
            width: 26px;
            height: 100%;
            content: "";
            background: ${() => `url(${ArrowSliderLeftSVG}) no-repeat center center`};
        }
        &.swiper-button-disabled {
            opacity: 0;
        }
    }
    & .swiper-button-prev {
        left: 10px;
    }
    & .swiper-button-next {
        right: 10px;
    }
    & .swiper-button-next:after {
        transform: rotate(180deg);
    }
    @media only screen and (${Breakpoints.TABLET}) {
        & .swiper-container {
            padding-bottom: 25px;
        }
    }
    @media only screen and (${Breakpoints.LAPTOP}) {
        & .swiper-container {
            padding-bottom: 45px;
        }
        & .swiper-scrollbar {
            width: 100%;
            max-width: 540px;
            left: 50%;
            right: unset;
            transform: translateX(-50%);
        }
    }
`;
export const JournalsSliderMainJournalsCard = styled(BasicJournalsCard)<{ opacity?: number }>`
    opacity: ${({ opacity }) => opacity};
    transition: opacity 200ms;
`;
